import { render, staticRenderFns } from "./SlideDown.vue?vue&type=template&id=6544240b&scoped=true"
import script from "./SlideDown.vue?vue&type=script&lang=js"
export * from "./SlideDown.vue?vue&type=script&lang=js"
import style0 from "./SlideDown.vue?vue&type=style&index=0&id=6544240b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6544240b",
  null
  
)

export default component.exports